<template>
    <div class="container mt-4">
        <div style="font-size: 18px;font-weight: bold;">Create New Device</div>
        <!-- <div>{{mqtt}}</div> -->
        <!-- <h4 class="mb-3">
            <i class="bi bi-person-plus-fill text-success"></i> Create New Device
        </h4> -->
        <!-- <div class="border-top border-success mb-4"></div> -->
        <div class="row mt-3">
            <div class="col-md-6">
                <div class="mb-3">
                    <label class="form-label"><i class="bi bi-envelope"></i> Device name</label>
                    <input type="email" class="form-control" placeholder="Name" v-model="device.name">
                </div>
                <div class="mb-3">
                    <label class="form-label"><i class="bi bi-person-badge"></i>Communication</label>
                    <select class="form-select" v-model="device.mode" @change="generateKey_MQTT()">
                        <option value="mqtt">MQTT</option>
                        <option value="api">API</option>
                    </select>
                </div>
                <div class="mb-3 px-3 py-3 rounded-4 bg-light" v-if="device.mode=='mqtt'" style="">
                    <div class="row">
                        <label class="form-label"><i class="bi bi-card-list"></i>Subscribe Topic</label>
                        <div class="col-10">
                            <input type="text" class="form-control" placeholder="@update/****" v-model="mqtt.topic">
                        </div>
                        <div class="col-2 text-end">
                            <button type="button" class="btn btn-primary"
                                @click="copyTextFallback(mqtt.id)">Copy</button>
                        </div>
                    </div>
                    <div class="row">
                        <label class="form-label"><i class="bi bi-card-list"></i>ID</label>
                        <div class="col-10">
                            <input type="text" class="form-control" placeholder="ID" v-model="mqtt.id">
                        </div>
                        <div class="col-2 text-end">
                            <button type="button" class="btn btn-primary"
                                @click="copyTextFallback(mqtt.id)">Copy</button>
                        </div>
                    </div>
                    <div class="row">
                        <label class="form-label"><i class="bi bi-card-list"></i>Username</label>
                        <div class="col-10">
                            <input type="text" class="form-control" placeholder="" v-model="mqtt.username">
                        </div>
                        <div class="col-2 text-end">
                            <button type="button" class="btn btn-primary"
                                @click="copyTextFallback(mqtt.username)">Copy</button>
                        </div>
                    </div>
                    <div class="row">
                        <label class="form-label"><i class="bi bi-card-list"></i>Password</label>
                        <div class="col-10">
                            <input type="text" class="form-control" placeholder="" v-model="mqtt.password">
                        </div>
                        <div class="col-2 text-end">
                            <button type="button" class="btn btn-primary"
                                @click="copyTextFallback(mqtt.password)">Copy</button>
                        </div>
                    </div>
                </div>

                <div v-else class="mb-3 px-3 py-3 rounded-4 bg-light" style="">
                    <div class="mb-3">
                        <label class="form-label"><i class="bi bi-person-badge"></i>API Type</label>
                        <select class="form-select" v-model="api.mode">
                            <option value="apikey">API Key</option>
                            <option value="basic">Basic</option>
                        </select>
                    </div>

                    <div v-if="api.mode=='apikey'">
                        <div class="mb-3">
                            <label class="form-label"><i class="bi bi-person-badge"></i>API Type</label>
                            <select class="form-select" v-model="api.in">
                                <option value="header">Header</option>
                                <option value="query">Query</option>
                            </select>
                        </div>
                        <label class="form-label"><i class="bi bi-card-list"></i>Key</label>
                        <div class="col-12">
                            <input type="text" class="form-control" placeholder="Key" v-model="api.key">
                        </div>

                        <label class="form-label mt-2"><i class="bi bi-card-list"></i>Value</label>
                        <div class="col-12">
                            <input type="text" class="form-control" placeholder="Value" v-model="api.value">
                        </div>
                    </div>
                    <div v-else-if="api.mode=='basic'">

                        <label class="form-label"><i class="bi bi-card-list"></i>Username</label>
                        <div class="col-12">
                            <input type="text" class="form-control" placeholder="Username" v-model="api.username">
                        </div>

                        <label class="form-label mt-2"><i class="bi bi-card-list"></i>Password</label>
                        <div class="col-12">
                            <input type="text" class="form-control" placeholder="Password" v-model="api.password">
                        </div>
                    </div>
                </div>
                <!-- <div class="mb-3">
                    <label class="form-label"><i class="bi bi-card-list"></i> Model</label>
                    <input type="text" class="form-control" placeholder="Model eg.IOT2025" v-model="fullName">
                </div> -->
            </div>
            <!-- Right Section -->
            <div class="col-md-6">
                <div class="mb-3">
                    <label class="form-label"><i class="bi bi-bookmark"></i>Template</label>
                    <select class="form-select" v-model="device.template_id" id="">
                        <option v-for="item in list_template" :key="item" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="mb-3">
                    <label class="form-label"><i class="bi bi-bookmark"></i>Plan</label>
                    <select class="form-select" v-model="device.plan_id" id="">
                        <option v-for="item in list_plan" :key="item" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="mb-3">
                    <label class="form-label"><i class="bi bi-bookmark"></i> Note</label>
                    <textarea class="form-control" rows="4" placeholder="Add a note..."
                        v-model="device.comment"></textarea>
                </div>

            </div>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-between mt-4">
            <button class="btn btn-danger px-4" @click="clearForm">
                <i class="bi bi-brush"></i> Clear
            </button>
            <button class="btn btn-secondary px-4" @click="createDevice()">
                <i class="bi bi-person-plus"></i> Create Device
            </button>
        </div>
    </div>

</template>

<script setup>
    import {
        ref
    } from "vue";

    const email = ref("");
    const fullName = ref("");
    const role = ref("User");
    const note = ref("");

    const clearForm = () => {
        email.value = "";
        fullName.value = "";
        role.value = "User";
        note.value = "";
    };
</script>
<script>
    import CryptoJS from "crypto-js";

    //   import jwt from "jsonwebtoken";
    export default {
        data() {
            return {
                list_template:[],
                list_plan:[],
                device: {
                    template_id:"",
                    plan_id:"",
                    name: "",
                    note: "",
                    mode: "api",
                    comment:""

                },
                api: {
                    mode: "basic",
                    in: "",
                    key: "",
                    value: "",
                    username: "",
                    password: ""
                },
                mqtt: {
                    id: "cxaksjyteqhw",
                    topic: "",
                    username: "",
                    password: ""
                }
            }
        },
        methods: {
            async getTemplateList() {
                try {
                    var accessToken = localStorage.getItem("accessToken");
                    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    const data = await response.json();
                    console.log("success:", data);
                    this.list_template = data.data;
                } catch (error) {
                    console.error("Upload error:", error);
                }
            },
            async getPlanList() {
                try {
                    var accessToken = localStorage.getItem("accessToken");
                    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/plan`, {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    const data = await response.json();
                    console.log("success:", data);
                    this.list_plan = data.data;
                } catch (error) {
                    console.error("Upload error:", error);
                }
            },
            generateKey_MQTT() {
                this.mqtt.id = CryptoJS.lib.WordArray.random(8).toString(CryptoJS.enc.Base64);
                this.mqtt.username = CryptoJS.lib.WordArray.random(12).toString(CryptoJS.enc.Base64);
                this.mqtt.password = CryptoJS.lib.WordArray.random(12).toString(CryptoJS.enc.Base64);
            },
            copyTextFallback(text) {
                const textarea = document.createElement("textarea");
                textarea.value = text;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            },

            async createDevice() {
                try {
                    var body_create_device;
                    if (this.device.mode == 'api') {
                        if (this.api.mode == 'apikey') {
                            body_create_device = {
                                "name": this.device.name,
                                "template_id":this.device.template_id,
                                "plan_id":this.device.plan_id,
                                "comment": this.device.comment,
                                "mode": this.device.mode,
                                "config": {
                                    "auth": {
                                        "type": this.api.mode,
                                        "in": this.api.in,
                                        "key": this.api.key,
                                        "value": this.api.value
                                    },
                                    // "deviceId": this.device.model
                                }
                            }
                        } else {
                            body_create_device = {
                                "name": this.device.name,
                                "template_id":this.device.template_id,
                                "plan_id":this.device.plan_id,
                                "comment": this.device.comment,
                                "mode": this.device.mode,
                                "config": {
                                    "auth": {
                                        "type": this.api.mode,
                                        "username": this.api.username,
                                        "password": this.api.password,
                                    },
                                    // "deviceId": this.device.model
                                }
                            }
                        }
                    } else if (this.device.mode == 'mqtt') {
                        body_create_device = {
                            "name": this.device.name,
                            "template_id":this.device.template_id,
                            "plan_id":this.device.plan_id,
                            "comment": this.device.comment,
                            "mode": this.device.mode,
                            "config": {
                                    "topic": this.mqtt.topic,
                                    "clientId": this.mqtt.id,
                                    "username": this.mqtt.username,
                                    "password": this.mqtt.password,
                                // "auth": {
                                //     "topic": this.mqtt.topic,
                                //     "id": this.mqtt.id,
                                //     "username": this.mqtt.username,
                                //     "password": this.mqtt.password,
                                // },
                                // "deviceId": this.device.model
                            }
                        }
                    }

                    var accessToken = localStorage.getItem("accessToken");
                    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        },
                        body: JSON.stringify(
                            body_create_device
                        )
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const result = await response.json();
                    this.$router.push('/device/list');

                    console.log('Dashboard page created:', result);
                } catch (error) {
                    console.error('Error creating dashboard page:', error);
                }
            },
        },
        created() {
            this.getTemplateList();
            this.getPlanList();
        }
    }
</script>

<style scoped>
    /* Add extra styling if needed */
</style>